import { IScaleAnalysis } from "@/modules/assessments/hooks/use-get-invite-scale-analyses.hook";
import styles from "./styles.module.css";

interface ScaleAnalysesProps {
  scaleAnalyses: IScaleAnalysis[];
}

export default function ScaleAnalyses({ scaleAnalyses }: ScaleAnalysesProps) {
  if (scaleAnalyses.length === 0) {
    return null;
  }

  // Group scale analyses by paragraphNumber
  const groupedAnalyses = scaleAnalyses.reduce((acc, analysis) => {
    if (!acc[analysis.paragraphNumber]) {
      acc[analysis.paragraphNumber] = [];
    }
    acc[analysis.paragraphNumber].push(analysis);
    return acc;
  }, {} as Record<number, typeof scaleAnalyses>);

  return (
    <section className={styles.scaleAnalysesContainer}>
      {Object.keys(groupedAnalyses).map((paragraphNumber) => (
        <div key={paragraphNumber} className={styles.paragraphSection}>
          <p className={styles.paragraphContent}>
            {groupedAnalyses[Number(paragraphNumber)].map((analysis: { content: string }) => `${analysis.content} `)}
          </p>
          <br />
        </div>
      ))}
    </section>
  );
}
